import React, { useEffect, useState } from "react";
import { googleLogout } from "@react-oauth/google";
import { useGoogleLogin } from "@react-oauth/google";
import axios from "axios";
import { SocialSignInResponseType } from "../../../libraries/types_interface/social/LoginSocialConnectTypes";
import { textCase } from "../../../service/ui/UI";

//import jwtDecode from "jwt-decode";

// const GOOGLE_client_id = process.env.REACT_APP_social_google_client_id;

type Props = {
  children: React.ReactNode;
  handleSuccess: (detail: SocialSignInResponseType) => void;
  handleFailure: (detail: any) => void;
};

/* interface GoogleUser {
  name: string;
  email: string;
  picture: string;
  sub: string; // Google's user ID
} */

/* interface CodeResponseType {
  code: string;
  scope: string;
  prompt: string;
} */

interface TokenResponseType {
  access_token: string;
  expires_in: number;
  scope: string;
  token_type: string;
}

export const GoogleSignIn: React.FC<Props> = ({
  children,
  handleFailure,
  handleSuccess,
}) => {
  const [isHuawei, setIsHuawei] = useState<boolean>(false);

  /*  const socialGoogleSuccess = async (
    credentialResponse: CredentialResponse
  ) => {
    if (!credentialResponse.credential) return;

    const token = credentialResponse.credential;
    console.log(`google toke: ${token}`, credentialResponse);
    // Decode token payload (client-side)
    //const decoded: GoogleUser = jwtDecode(token);

    if (typeof handleSuccess === "function") {
      handleSuccess(token);
    }

    googleLogout();
  }; */

  const socialGoogleFailure = () => {};

  const googleSignIn = useGoogleLogin({
    onSuccess: async (token: TokenResponseType) => {
      const response = await axios.get(
        "https://www.googleapis.com/oauth2/v3/userinfo",
        {
          headers: {
            Authorization: `Bearer ${token.access_token}`,
          },
        }
      );

      console.log(response);

      if (typeof handleSuccess === "function") {
        handleSuccess({
          id: response.data["sub"],
          name: textCase(response.data["name"]),
          first_name: textCase(response.data["given_name"] ?? ""),
          last_name: textCase(response.data["family_name"] ?? ""),
          photo: response.data["name"],
          email: response.data["email"],
          socialType: "2",
        });
      }

      googleLogout();
      /* setUser({
        name: res.data.name,
        email: res.data.email,
        picture: res.data.picture,
      }); */
    },
    onError: (errorResponse) => socialGoogleFailure(),
    //flow: "auth-code",
  });

  useEffect(() => {
    // CHECK BROWER IF HAUWEI
    const agentBrowser: string = (
      window.navigator.appVersion ?? ""
    ).toLowerCase();
    let position: number = agentBrowser.search("huaweibrowser");
    setIsHuawei(position > 0 ? true : false);
  }, []);

  return (
    <>
      {!isHuawei && (
        <div className="social-login-wrap">
          <div
            className="social-login-child"
            role="button"
            onClick={() => googleSignIn()}
          >
            {children}
          </div>
        </div>
      )}
    </>
  );
};
